/** Max profile image size (MB) for v4 pet create/upload in admin. */
export const PET_PROFILE_IMAGE_MAX_SIZE_MB = 5;

/** Bytes per MB — inlined to avoid importing `file.constants` (it pulls `interfaces` → `pet` → this file = cycle). */
const BYTES_PER_MB = 1024 * 1024;

/** Max profile image size in bytes (used with `File.size`). */
export const PET_PROFILE_IMAGE_MAX_BYTES = PET_PROFILE_IMAGE_MAX_SIZE_MB * BYTES_PER_MB;

/** HTML `accept` and MIME allow-list for pet profile uploads. */
export const PET_PROFILE_IMAGE_ACCEPT = "image/jpeg,image/png,image/webp" as const;

/** Minimum allowed date in pet DOB picker (Jan 1, 1950). */
export const PET_DOB_MIN_DATE = new Date(1950, 0, 1);

export const PET_SPECIES = [
  { value: "dog", label: "Dog" },
  { value: "cat", label: "Cat" },
  { value: "other", label: "Other" },
];

export const PET_GENDERS = [
  { value: "MALE", label: "Male" },
  { value: "FEMALE", label: "Female" },
  { value: "OTHER", label: "Other" },
];

/** Pet notes / behavior interaction level (kept here to avoid `constants` barrel ↔ `interfaces` cycles). */
export enum PetInteractionLevel {
  NOT_COMFORTABLE = "NOT_COMFORTABLE",
  UNCOMFORTABLE_SOMETIMES = "UNCOMFORTABLE_SOMETIMES",
  MOSTLY_COMFORTABLE = "MOSTLY_COMFORTABLE",
  VERY_COMFORTABLE = "VERY_COMFORTABLE",
}